/*
 * Attribution commerciale Penlab (QR codes cartes de visite).
 * - rep_id / rep_name : identifiants internes du commercial, jamais de donnee personnelle visiteur.
 * - Regle FIRST TOUCH : la premiere attribution stockee ne peut jamais etre ecrasee,
 *   ni par une visite ulterieure sans ?rep, ni par un ?rep different (carte d'un autre commercial).
 * - Stockage : localStorage (survit a une fermeture de navigateur, contrairement a sessionStorage),
 *   necessaire pour couvrir le scenario "retour 5 jours plus tard". Comme pour la capture UTM deja
 *   en place sur le site, ce stockage n'est pas soumis au consentement cookies : ce sont des
 *   identifiants commerciaux internes, pas des donnees personnelles du visiteur, et aucune donnee
 *   n'est envoyee a un tiers par ce script lui-meme (seul l'envoi GA4 reste conditionne au consentement,
 *   deja gere par penlabTrack).
 * - Marketing attribution (utm_source/medium/campaign generiques) reste geree separement par le
 *   script deja present sur /pages/demander-un-devis : ce fichier ne la modifie pas.
 */
(function () {
  var STORAGE_KEY = 'penlab_sales_rep';

  function safeGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, value) {
    try { localStorage.setItem(key, value); return true; } catch (e) { return false; }
  }

  function getStoredAttribution() {
    var raw = safeGet(STORAGE_KEY);
    if (!raw) return null;
    try {
      var data = JSON.parse(raw);
      if (data && data.rep_id) return data;
    } catch (e) {}
    return null;
  }

  function captureAttributionFromUrl() {
    var existing = getStoredAttribution();
    if (existing) return existing; // FIRST TOUCH : ne jamais ecraser une attribution deja stockee.

    var params = new URLSearchParams(window.location.search);
    var repParam = params.get('rep');
    if (!repParam) return null;

    var reps = (window.PenlabSalesReps || {});
    var repConfig = reps[repParam];
    if (!repConfig) return null; // rep inconnu/invalide -> on ignore silencieusement, pas d'erreur.

    var attribution = {
      rep_id: repParam,
      rep_name: repConfig.name || repParam,
      first_touch_timestamp: new Date().toISOString(),
      landing_page: window.location.pathname + window.location.search,
      source: params.get('utm_source') || '',
      medium: params.get('utm_medium') || '',
      campaign: params.get('utm_campaign') || ''
    };
    safeSet(STORAGE_KEY, JSON.stringify(attribution));
    return attribution;
  }

  function syncCartAttributes(attribution) {
    if (!attribution) return;
    // Necessite un panier deja existant (Shopify cree le panier au premier ajout produit) ;
    // on tente a chaque chargement de page, silencieusement si aucun panier n'existe encore.
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.attributes && cart.attributes.rep_id) return; // deja synchronise sur ce panier.
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              rep_id: attribution.rep_id,
              rep_name: attribution.rep_name,
              rep_first_touch: attribution.first_touch_timestamp,
              rep_landing_page: attribution.landing_page,
              rep_source: attribution.source,
              rep_medium: attribution.medium,
              rep_campaign: attribution.campaign
            }
          })
        });
      })
      .catch(function () {});
  }

  function setGA4DefaultParam(attribution) {
    // gtag('set', ...) definit un parametre par defaut applique a TOUS les evenements GA4
    // envoyes ensuite sur cette page, y compris les evenements natifs automatiques de Shopify
    // (view_item, add_to_cart, begin_checkout, purchase) que notre code ne declenche pas
    // lui-meme. C'est le seul moyen de rattacher rep_id a ces evenements natifs.
    // Ne s'execute que si gtag existe deja (donc apres consentement), comme le reste du tracking.
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('set', { rep_id: attribution.rep_id });
      }
    } catch (e) {}
  }

  var attribution = captureAttributionFromUrl();
  window.PenlabSalesRepAttribution = attribution; // lu par penlab-analytics.js et le formulaire de devis.
  if (attribution) {
    syncCartAttributes(attribution);
    setGA4DefaultParam(attribution);
  }
})();
